import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import bem from '../../../common/bem'

export default class PageSection extends Component {

  constructor() {
    super()
  }

  render() {
    let bemmer = bem('pagesection')
    let { children, type, defaultStyle, bgImg, className } = this.props
    let bgImgStyle = bgImg ? {backgroundImage: `url(${bgImg})`} : {};
    let style = Object.assign(defaultStyle, bgImgStyle)
    return (
      <section
        style={style}
        className={`${bemmer.element('container').modifier(type)} ${className}`}>
        { children }
      </section>
    )
  }
}

PageSection.defaultProps = {
  className: '',
  type: null,
  defaultStyle: {
    backgroundImage: null,
    backgroundSize: 'cover',
    backgroundPosition: 'center'
  }
}

PageSection.propTypes = {
  bgImg: PropTypes.string,
  type: React.PropTypes.oneOf(['primary','secondary', null]),
}



// WEBPACK FOOTER //
// ./component/ui/Page/PageSection.js